import { PageService } from '@buildium/angularjs-core/dist/definitions/browser/page';

export class EsignaturesCanceledController {
    static $inject: string[] = ['Page'];

    constructor(
        private Page: PageService
    ) {
        this.Page.mainContentNoBottomPadding = true;
        Page.addBodyClass('esignatures-public-background');
    }
}
